/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CropReport } from '../../models/crop-report';

export interface GetCropReportByFacilityId$Params {
  facilityId: number;
}

export function getCropReportByFacilityId(http: HttpClient, rootUrl: string, params: GetCropReportByFacilityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CropReport>>> {
  const rb = new RequestBuilder(rootUrl, getCropReportByFacilityId.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CropReport>>;
    })
  );
}

getCropReportByFacilityId.PATH = '/api/cropreport/facility/{facilityId}';
